var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBurgerWhite = function SvgBurgerWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1826_4804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 2.198H1.33325C0.598633 2.198 0 2.62335 0 3.14532V5.04015C0 5.56212 0.598633 5.98747 1.33325 5.98747H22.6667C23.4014 5.98747 24 5.56212 24 5.04015V3.14532C24 2.62335 23.4014 2.198 22.6667 2.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 9.31226H1.33325C0.598633 9.31226 0 9.73761 0 10.2596V12.1544C0 12.6764 0.598633 13.1017 1.33325 13.1017H22.6667C23.4014 13.1017 24 12.6764 24 12.1544V10.2596C24 9.73761 23.4014 9.31226 22.6667 9.31226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 16.4211H1.33325C0.598633 16.4211 0 16.8465 0 17.3685V19.2633C0 19.7853 0.598633 20.2106 1.33325 20.2106H22.6667C23.4014 20.2106 24 19.7853 24 19.2633V17.3685C24 16.8465 23.4014 16.4211 22.6667 16.4211Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1826_4804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurgerWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/burgerWhite.39fe62f0.svg";
export { ForwardRef as ReactComponent };